import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Artikel } from '../../store/models/artikel';
import { Advertise } from '../../store/models/advertise';

@Injectable({
    providedIn: 'root'
})
export class ArtikelsService {

    constructor(
        private restService: RestService,
    ) { }

    getListFilter(pageNumber?: number,
        pageSize?: number,
        sortField: string = "nr",
        sortDirection: string = "asc",
        category: string = "",
        minPreis: number = 0,
        maxPreis: number = 0,
        filterGroessen: string = "",
        filterFarben: string = "",
        filterMerkmale: string = "",
        searchTerm: string = "",
        nurAufLager: boolean = false,
    ) : Observable<Artikel.IArtikelListDto> {

        let skipCount = pageNumber * pageSize;
        let sorting = sortField + ' ' + sortDirection;

        return this.restService.request<void, Artikel.IArtikelListDto>({
            method: 'GET',
            url: '/api/app/artikel/filter?Sorting=' + sorting + 
                '&SkipCount=' + skipCount + 
                '&MaxResultCount=' + pageSize +
                '&category=' + category + 
                '&minPreis=' + minPreis + 
                '&maxPreis=' + maxPreis + 
                '&filterGroessen=' + filterGroessen +
                '&filterFarben=' + filterFarben +
                '&filterMerkmale=' + filterMerkmale +
                '&searchTerm=' + searchTerm + 
                '&nurAufLager=' + nurAufLager
        });
    }

    getListAktionsartikelAsync(): Observable<Artikel.IArtikelDto[]> {
        return this.restService.request<void, Artikel.IArtikelDto[]>({
            method: 'GET',
            url: '/api/app/artikel/aktionsartikel'
        });
    }

    getListArtikelMatrixForArtikel(artikelKennung: number): Observable<Artikel.IArtikelDto[]> {
        return this.restService.request<void, Artikel.IArtikelDto[]>({
            method: 'GET',
            url: '/api/app/artikel/artikel-matrix-for-artikel?artikelKennung=' + artikelKennung
        });
    }

    getListArtikelZubehoerForArtikel(artikelKennung: number): Observable<Artikel.IArtikelDto[]> {
        return this.restService.request<void, Artikel.IArtikelDto[]>({
            method: 'GET',
            url: '/api/app/artikel/artikel-zubehoer-for-artikel?artikelKennung=' + artikelKennung
        });
    }

    getListAdvertiseAsync(): Observable<Advertise.IAdvertiseDto[]> {
        return this.restService.request<void, Advertise.IAdvertiseDto[]>({
            method: 'GET',
            url: '/api/app/artikel/advertise'
        });
    }

}
